import styled from "styled-components";
import { viewSizes } from "./variables";

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10rem auto;
  width: 50%;

  @media only screen and (max-width: ${viewSizes.tablet}) {
    width: 90%;
  }
`;
